<template>
  <div
    v-if="fromLogin"
    class="tw-text-right tw-cursor-pointer tw-pr-[20px] tw-pt-[20px]"
    :class="`${fromLogin ? 'tw-h-[39px]' : ''}`"
  >
    <img
      class="cross_icon tw-h-[19px] tw-w-[19px]"
      src="/img/cross-x_icon.svg"
      alt="cross"
      @click="closeModal"
    />
  </div>
  <div
    class="tw-flex tw-flex-col tw-p-5"
    :class="`${
      fromLogin
        ? 'from-login md:tw-p-[70px] md:tw-pt-[31px]'
        : 'md:tw-p-10 tw-gap-10'
    }`"
  >
    <div
      class="tw-flex tw-flex-col tw-font-[Poppins]"
      :class="`${fromLogin ? 'tw-gap-[15px] tw-pb-[30px]' : 'tw-gap-[10px]'}`"
    >
      <div
        class="tw-font-semibold tw-leading-[100%]"
        :class="`${
          fromLogin
            ? 'tw-text-[26px] tw-text-[#0345BD]'
            : 'tw-text-[25px] tw-text-[#211F58]'
        }`"
      >
        {{
          getComponentUiText(
            "app-settings-team-members-modal-mfa-selection-title-1",
          )
        }}
      </div>
      <div class="tw-text-[#231F20] tw-text-[15px] tw-leading-[145%]">
        {{
          multipleOptionsRef
            ? getComponentUiText(
                "app-settings-team-members-modal-mfa-selection-content-a-1",
              )
            : getComponentUiText(
                "app-settings-team-members-modal-mfa-selection-content-b-1",
              )
        }}
      </div>
    </div>
    <div
      class="tw-text-[15px] tw-flex md:tw-flex-row tw-flex-col tw-text-[#211F58] tw-font-medium tw-leading-[100%] tw-gap-[26px]"
    >
      <div
        v-if="multipleOptionsRef"
        data-cy="totp-selection-button-setup-authen"
        class="tw-cursor-pointer tw-justify-center tw-flex tw-flex-col tw-items-center tw-bg-[#F2F8FF] select_option tw-px-[40px] tw-py-[30px] tw-gap-[20px] tw-flex-1"
        @click="handleByAuthen"
      >
        <img v-if="!fromLogin" src="@/assets/img/phoneImageMfa.png" />
        <img v-else src="@/assets/img/mfaAuthen.png" />
        <div class="text-image">
          {{
            getComponentUiText(
              "app-settings-team-members-modal-mfa-selection-button-title-setup-authen-1",
            )
          }}
        </div>
      </div>
      <div
        class="tw-cursor-pointer tw-justify-center tw-flex tw-flex-col tw-items-center tw-bg-[#F2F8FF] select_option tw-px-[40px] tw-py-[30px] tw-gap-[20px] tw-flex-1"
        @click="handleByPasskey"
      >
        <img v-if="!fromLogin" src="@/assets/img/phoneImageMfa.png" />
        <img v-else src="@/assets/img/mfaPasskey.png" />
        <div class="text-image">
          {{
            getComponentUiText(
              "app-settings-team-members-modal-mfa-selection-button-title-setup-passkey-1",
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";

const props = defineProps({
  multipleOptions: {
    type: Boolean,
    required: false,
  },
  fromLogin: {
    type: Boolean,
    required: false,
  },
});

const multipleOptionsRef = ref(props.multipleOptions);

watch(
  () => props.multipleOptions,
  (value) => {
    multipleOptionsRef.value = value;
  },
);

const emit = defineEmits([
  "update:click:passkey",
  "update:click:authen",
  "close",
]);

const handleByPasskey = () => {
  emit("update:click:passkey");
};

const handleByAuthen = async () => {
  emit("update:click:authen");
};

const closeModal = () => {
  emit("close");
};
</script>

<style lang="scss" scoped>
.select_option {
  border-radius: 4px;
  border: 1px solid var(--UI-light-sky-soft, #e4f1ff);
  font-family: Poppins;
}
.from-login {
  .text-image {
    color: #211f58;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    width: 150px;
    text-align: center;
  }
}
</style>
